import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from 'react-router-dom';
import backButton from "../../../assets/images/back_button.svg";
import { useStyles } from '../../../assets/jss/MileageClaimDetailsPage';
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import CustomBox from '../../../components/CustomComponents/CustomBox/CustomBox';
import CustomGrid from '../../../components/CustomComponents/CustomGrid/CustomGrid';
import CustomTypography from "../../../components/CustomComponents/CustomTypography/CustomTypography";
import { MileageClaimStatusEnum, Role, TripTypeEnum } from "../../../config/app-globals.enum";
import CustomCircularProgress from '../../../components/CustomComponents/CustomCircularProgress/CustomCircularProgress';
import CustomPaper from '../../../components/CustomComponents/CustomPaper/CustomPaper';
import ErrorAlert from '../../../components/ErrorAlert/ErrorAlert';
import { GetDriverTripListForMileageClaim, approveRejectMileageClaim, getMileageClaimDetails } from '../../../services/MileageClaimAPIService';
import { meterToMiles } from "../../../assets/helperFunctions";
import moment from "moment";
import classNames from "classnames";
import CustomButton from '../../../components/CustomComponents/CustomButton/CustomButton';
import { ButtonBase, Divider } from '@material-ui/core';
import DateTime from '../../../components/DateTime/DateTime';
import clsx from 'clsx';
import MileageClaimActionDialog from '../../../components/Dialogs/ConfirmAction/MileageClaimAction';
import { getUserData } from '../../../services/LocalStorageService';


const MileageClaimDetails = (props) => {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    const params = useParams();
    const [userData] = React.useState(getUserData());

    const [isLoading, setIsLoading] = useState(false);
    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);
    const [mileageClaimDetailsData, setMileageClaimDetailsData] = useState(null);

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    async function getMileageClaimsData() {
        setStatusValue(null);
        setAlertMessage("");
        setIsAlertOpen(false);
        setIsLoading(true);
        setShowTrips(false);
        setTripList([]);

        const data = await getMileageClaimDetails(params.userId, params.mileageClaimId);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content) {

            setMileageClaimDetailsData(data.content);
            setIsLoading(false);
            changeApiStatusCodeFunc(data.status);
        } else {
            changeApiStatusCodeFunc(data.status);
        }
    }

    useEffect(() => {
        getMileageClaimsData();
    }, [props.userId]);

    const goBackFunc = () => {
        // (params.impersonationid && history.length > 1) || !params.impersonationid ? history.push('/admin/') : history.push(`/dashboard/impersonation/${params.impersonationid}`);
        history.back();
    }

    const formatDate = (date: Date) => {
        let formatedDate = "";
        try {
            formatedDate = moment(date).format('DD MMM YYYY');
        } catch (error) {
        }
        return formatedDate;
    }

    const [mileageClaimDetailsStatus, setMileageClaimDetailsStatus] = useState(MileageClaimStatusEnum.CLAIMED);
    const [mileageClaimDialogOpen, setMileageClaimDialogOpen] = useState(false);
    const [isTripListLoading, setIsTripListLoading] = useState(false);
    const [tripList, setTripList] = useState([]);
    const [showTrips, setShowTrips] = useState(false);
    const showTripsMethod = () => {
        if (showTrips === false) {
            getDriversTripList();
        }
        setShowTrips(!showTrips);
    }

    useEffect(() => {
        if (mileageClaimDialogOpen === false) {
            setMileageClaimDetailsStatus(MileageClaimStatusEnum.CLAIMED);
        }
    }, [mileageClaimDialogOpen])


    async function getDriversTripList() {
        if (isTripListLoading) {
            return;
        }
        setIsTripListLoading(true);
        var parameters = {
            userId: params.userId,
            fromDate: mileageClaimDetailsData.claimFrom,
            toDate: mileageClaimDetailsData.claimTo,
            tripTypes: [TripTypeEnum.NOT_DRIVING, TripTypeEnum.OTHER]
        };
        const data = await GetDriverTripListForMileageClaim(parameters);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content) {
            if (data.content.length > 0) {
                data.content.sort((a, b) => new Date(b.endTime).getTime() - new Date(a.endTime).getTime());
                for (let i = 0; i < data.content.length; i++) {
                    const trip = data.content[i];
                    const startAddress = getAddressFromObject(trip.startAddress);
                    const endAddress = getAddressFromObject(trip.endAddress);
                    trip['formattedStartAddress'] = startAddress;
                    trip['formattedEndAddress'] = endAddress;
                }
            }
            setTripList(data.content);
        } else {
            changeApiStatusCodeFunc(data.status);
        }
        setIsTripListLoading(false);
        changeApiStatusCodeFunc(data.status);
    }

    const rejectMileageClaimDialogFunc = (isOpen, confirmDelete, reason) => {
        if (confirmDelete) {
            if (mileageClaimDetailsStatus === MileageClaimStatusEnum.APPROVED) {
                handleMileageClaimApproveReject(mileageClaimDetailsData, MileageClaimStatusEnum.APPROVED, null);
            } else if (mileageClaimDetailsStatus === MileageClaimStatusEnum.REJECTED) {
                handleMileageClaimApproveReject(mileageClaimDetailsData, MileageClaimStatusEnum.REJECTED, reason);
            }
        } else {
            setMileageClaimDialogOpen(isOpen);
        }
    };

    async function handleMileageClaimApproveReject(req, mileageClaimStatus, reason) {
        let request = {
            userId: params.userId,
            status: mileageClaimStatus,
            reason: null
        }

        if (reason && reason.length > 0) {
            request = {
                ...request,
                reason: reason,
            }
        }
        const data = await approveRejectMileageClaim(request, req._id);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201)
        ) {
            changeMileageClaimApiStatusCodeFunc(data.status, mileageClaimStatus);
            // setTimeout(() => {
            //     handleRefreshComponent(mileageClaimStatus);
            //     window.localStorage.removeItem("API");
            // }, 1000);
            getMileageClaimsData();
            //@todo reload data
        } else {
            changeMileageClaimApiStatusCodeFunc(data.status, mileageClaimStatus);
        }
        setMileageClaimDialogOpen(false);
    }

    const [eventStatusValue, setEventStatusValue] = React.useState(null);
    const [eventAlertMessage, setEventAlertMessage] = React.useState("");
    const [eventAlertType, setEventAlertType] = React.useState("");
    const [eventAlertDescription, setEventAlertDescription] = React.useState("");
    const [isEventAlertOpen, setIsEventAlertOpen] = React.useState(false);
    const changeMileageClaimApiStatusCodeFunc = (status, action) => {
        setEventStatusValue(status.code);
        if (status.code === 0 || status.code === 200 || status.code === 201) {
            setEventAlertMessage(status.message ? status.message : t("SUCCESS"));
            setEventAlertType("success");
            let eventDescription = "";
            if (action === MileageClaimStatusEnum.CLAIMED) {
                eventDescription = t("MILEAGE_HAS_BEEN_CLAIMED_SUCCESSFULLY");
            } else if (action === MileageClaimStatusEnum.APPROVED) {
                eventDescription = t("MILEAGE_HAS_BEEN_APPROVED_SUCCESSFULLY");
            } else if (action === MileageClaimStatusEnum.REJECTED) {
                eventDescription = t("MILEAGE_HAS_BEEN_REJECTED_SUCCESSFULLY");
            }

            setEventAlertDescription(eventDescription);
        } else {
            setEventAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setEventAlertType("error");
            let eventDescription = "";
            if (action === MileageClaimStatusEnum.CLAIMED) {
                eventDescription = t("FAILED_TO_CLAIM_MILEAGE");
            } else if (action === MileageClaimStatusEnum.APPROVED) {
                eventDescription = t("FAILED_TO_APPROVE_MILEAGE");
            } else if (action === MileageClaimStatusEnum.REJECTED) {
                eventDescription = t("FAILED_TO_REJECT_MILEAGE");
            }
            setEventAlertDescription(eventDescription);
        }
        setIsEventAlertOpen(true);
    };

    const getMileageClaimStatusBox = (mileageClaimDetailsData) => {
        try {
            if (mileageClaimDetailsData && mileageClaimDetailsData.status) {
                if (mileageClaimDetailsData.status === MileageClaimStatusEnum.CLAIMED) {
                    return <CustomBox className={classes.statusBoxOuter}>
                        <CustomBox className={classNames(classes.statusClaimed, classes.statusBoxInner)}>
                            {t('STATUS')}: {t('CLAIMED')}
                        </CustomBox>
                    </CustomBox>
                } else if (mileageClaimDetailsData.status === MileageClaimStatusEnum.APPROVED) {
                    return <CustomBox className={classes.statusBoxOuter}>
                        <CustomBox className={classNames(classes.statusApproved, classes.statusBoxInner)}>
                            {t('STATUS')}: {t('APPROVED')}
                        </CustomBox>
                    </CustomBox>
                } else if (mileageClaimDetailsData.status === MileageClaimStatusEnum.REJECTED) {
                    return <CustomBox className={classes.statusBoxOuter}>
                        <CustomBox className={classNames(classes.statusRejected, classes.statusBoxInner)}>
                            {t('STATUS')}: {t('REJECTED')}
                        </CustomBox>
                    </CustomBox>
                }
            }
        } catch (error) { }
        return '';
    }

    const actionButtonClicked = (mileageClaimStatusEnum: MileageClaimStatusEnum) => {
        setMileageClaimDetailsStatus(mileageClaimStatusEnum);
        setMileageClaimDialogOpen(true);
    }

    const getAddressFromObject = (addressObject) => {
        let address = '';
        try {
            if (addressObject) {
                if (addressObject.subLocality !== undefined && addressObject.subLocality !== null) {
                    address += addressObject.subLocality + ', ';
                }
                if (addressObject.locality !== undefined && addressObject.locality !== null) {
                    address += addressObject.locality + ', ';
                }
                if (addressObject.subAdminArea !== undefined && addressObject.subAdminArea !== null) {
                    address += addressObject.subAdminArea + ', ';
                }
                if (addressObject.adminArea !== undefined && addressObject.adminArea !== null) {
                    address += addressObject.adminArea + ', ';
                }
                if (addressObject.countryName !== undefined && addressObject.countryName !== null) {
                    address += addressObject.countryName + ', ';
                }
                if (addressObject.postalCode !== undefined && addressObject.postalCode !== null) {
                    address += addressObject.postalCode;
                }
            }
        } catch (error) {

        }
        return address === '' ? t(`LOCATION_DATA_NOT_FOUND`) : address; //address.replace(/, +$/, '');
    }

    return (
        <>
            <CustomGrid container spacing={4} justifyContent="space-between">
                <CustomGrid item xs={12}>
                    <Breadcrumb
                        currentPage={t("MILEAGE_CLAIMS")}
                    />
                </CustomGrid>
            </CustomGrid>
            <CustomBox item>
                <CustomTypography
                    component="h1"
                    variant="h5"
                    className={classes.headerTitle}>
                    <img
                        src={backButton}
                        onClick={goBackFunc}
                        style={{ marginRight: "20px", cursor: "pointer" }}
                        alt="Back"
                    />
                    {t("MILEAGE_CLAIMS")}
                </CustomTypography>
            </CustomBox>

            <CustomGrid container spacing={1} justifyContent="center">
                <CustomGrid item lg={4} md={6} xs={12}>
                    {isLoading && <CustomPaper style={{ padding: "20px", valign: "center" }}>
                        <h3 className={classes.headerTitle}>
                            <CustomCircularProgress />
                            {t('Loading')}
                        </h3>
                    </CustomPaper>}
                    {mileageClaimDetailsData && !isLoading &&
                        <CustomPaper style={{ minHeight: '500px' }}>
                            <CustomBox padding={2}>
                                <CustomBox>
                                    {getMileageClaimStatusBox(mileageClaimDetailsData)}
                                    <h2 className={classes.headerTitle}>{t('MILEAGE_CLAIM_DETAILS')}</h2>
                                </CustomBox>
                                <CustomBox>
                                    <CustomGrid container spacing={4} justifyContent="space-between">
                                        <CustomGrid item xs={6}>
                                            <CustomBox className={classes.boxHeader}>
                                                {t('DATE')}
                                            </CustomBox>
                                            <CustomBox className={classes.boxOuter}>
                                                {formatDate(new Date(mileageClaimDetailsData.claimFrom))}
                                            </CustomBox>
                                        </CustomGrid>
                                        <CustomGrid item xs={6}>
                                            <CustomBox>
                                                &nbsp;
                                            </CustomBox>
                                            <CustomBox className={classes.boxOuter}>
                                                {formatDate(new Date(mileageClaimDetailsData.claimTo))}
                                            </CustomBox>
                                        </CustomGrid>
                                    </CustomGrid>
                                </CustomBox>
                                <CustomBox>
                                    <CustomGrid container spacing={4} justifyContent="space-between">
                                        <CustomGrid item xs={6}>
                                            <CustomBox className={classes.boxHeader}>
                                                {t('DISTANCE')}
                                            </CustomBox>
                                            <CustomBox className={classes.boxOuter}>
                                                {meterToMiles(mileageClaimDetailsData.distanceInMeter, false)}
                                            </CustomBox>
                                        </CustomGrid>
                                        <CustomGrid item xs={6}>
                                            <CustomBox className={classes.boxHeader}>
                                                {t('DISTANCE_UNIT')}
                                            </CustomBox>
                                            <CustomBox className={classes.boxOuter}>
                                                {t('MILES')}
                                            </CustomBox>
                                        </CustomGrid>
                                    </CustomGrid>
                                </CustomBox>
                                <CustomBox>
                                    <CustomGrid container spacing={4} justifyContent="space-between">
                                        <CustomGrid item xs={12}>
                                            <CustomBox className={classes.boxHeader}>
                                                {t('PRICE_PER_MILE')}
                                            </CustomBox>
                                            <CustomBox className={classes.boxOuter}>
                                                £ {mileageClaimDetailsData.pricePerMile}
                                            </CustomBox>
                                        </CustomGrid>
                                    </CustomGrid>
                                </CustomBox>
                                <CustomBox>
                                    <CustomGrid container spacing={4} justifyContent="space-between">
                                        <CustomGrid item xs={12}>
                                            <CustomBox className={classes.boxHeader}>
                                                {t('TOTAL_COST')}
                                            </CustomBox>
                                            <CustomBox className={classes.boxOuter}>
                                                £ {mileageClaimDetailsData.totalCost && mileageClaimDetailsData.totalCost.toFixed(2)}
                                            </CustomBox>
                                        </CustomGrid>
                                    </CustomGrid>
                                </CustomBox>
                                <CustomBox className={classes.buttonOuterBox}>

                                    {userData && userData.userRoleId !== Role.DRIVER && mileageClaimDetailsData.status === MileageClaimStatusEnum.CLAIMED &&
                                        <>
                                            <CustomButton
                                                // disabled={!isInputValid}
                                                vis
                                                onClick={() => actionButtonClicked(MileageClaimStatusEnum.APPROVED)}
                                                color="primary"
                                                className={classes.noBackground}
                                                defaultrounded="true"
                                            >
                                                {t("APPROVE")}
                                            </CustomButton>
                                            <CustomButton
                                                // disabled={!isInputValid}
                                                vis
                                                onClick={() => actionButtonClicked(MileageClaimStatusEnum.REJECTED)}
                                                color="secondary"
                                                className={classes.noBackground}
                                                defaultrounded="true"
                                            >
                                                {t("REJECT")}
                                            </CustomButton>
                                        </>}

                                    {!showTrips && <CustomButton
                                        className={classes.deleteView}
                                        onClick={() => showTripsMethod()}
                                        variant="contained"
                                        color="primary"
                                        defaultrounded="true"
                                    >
                                        {t("SHOW_TRIPS")}
                                    </CustomButton>}

                                </CustomBox>
                            </CustomBox>
                        </CustomPaper>}
                </CustomGrid>

                {showTrips &&
                    <CustomGrid item lg={3} md={6} xs={6} style={{ maxWidth: "350px" }}>
                        {isTripListLoading && <CustomPaper style={{ padding: "20px", valign: "center" }}>
                            <h3 className={classes.headerTitle}>
                                <CustomCircularProgress />
                                {t('Loading')}
                            </h3>
                        </CustomPaper>}
                        {mileageClaimDetailsData && !isTripListLoading &&
                            <CustomPaper style={{ maxHeight: '500px', overflow: 'auto' }}>
                                <CustomBox padding={2}>
                                    <h3 className={classes.headerTitle} style={{ marginTop: '0px' }}>
                                        {t('TRIP_LIST')}
                                    </h3>
                                    {tripList && (tripList.length > 0) && tripList.map((trip, index) => {
                                        return <ButtonBase key={index} component="div" style={{ display: 'block' }}>
                                            <CustomBox className={clsx(classes.tripsListItem)}>
                                                <CustomBox className={classes.tripsListItemRow}>
                                                    <CustomBox className={classes.tripsListItemIconBox}>
                                                        <CustomBox className={clsx(classes.tripsListItemIconStart)}>
                                                        </CustomBox>
                                                        <CustomBox className={classes.dottedLine}></CustomBox>
                                                    </CustomBox>
                                                    <CustomBox className={classes.tripsListItemSideBox}>
                                                        <CustomBox className={trip.formattedStartAddress === t(`LOCATION_DATA_NOT_FOUND`) ? classes.eventNoAddress : classes.eventAddress}>
                                                            {trip.formattedStartAddress}
                                                        </CustomBox>
                                                        <CustomBox className={classes.eventDate}>
                                                            <DateTime inputDate={trip.startTime} returnFormat="DD MMM YYYY" /> |{" "}<DateTime inputDate={trip.startTime} returnFormat="hh:mm A" />
                                                        </CustomBox>
                                                    </CustomBox>
                                                </CustomBox>
                                                <CustomBox className={classes.tripsListItemRow}>
                                                    <CustomBox className={classes.tripsListItemIconBox}>
                                                        <CustomBox className={clsx(classes.tripsListItemIconEnd)}>

                                                        </CustomBox>
                                                    </CustomBox>
                                                    <CustomBox className={classes.tripsListItemSideBox}>
                                                        <CustomBox className={trip.formattedEndAddress === t(`LOCATION_DATA_NOT_FOUND`) ? classes.eventNoAddress : classes.eventAddress}>
                                                            {trip.formattedEndAddress}
                                                        </CustomBox>
                                                        <CustomBox className={classes.eventDate}>
                                                            <DateTime inputDate={trip.endTime} returnFormat="DD MMM YYYY" /> |{" "}<DateTime inputDate={trip.endTime} returnFormat="hh:mm A" />
                                                        </CustomBox>
                                                    </CustomBox>
                                                </CustomBox>
                                                <CustomBox className={clsx(classes.tripsListItemRow, classes.tripsListItemRowCenter)}>
                                                    <CustomGrid container alignItems="center" justifyContent="space-between">
                                                        <CustomGrid item className={classes.eventsSeverityCount}>
                                                            {t('MILEAGE')}: {+(trip.distance.toFixed(2))} {t('MILES')}
                                                        </CustomGrid>
                                                        <CustomGrid item className={classes.eventsSeverityCount}>
                                                            {t('TOTAL_COST')}: £ {+((trip.distance * mileageClaimDetailsData.pricePerMile).toFixed(2))}
                                                        </CustomGrid>
                                                    </CustomGrid>
                                                    {trip.tripType === 0 && <CustomBox className={classes.eventsType}>
                                                        {t(`PERSONAL_TRIP`)}
                                                    </CustomBox>}

                                                </CustomBox>
                                            </CustomBox>
                                            <Divider light />
                                        </ButtonBase>
                                    })}
                                    {tripList && (tripList.length === 0) &&
                                        <CustomBox>
                                            {t('NO_RESULT_FOUND')}
                                        </CustomBox>
                                    }
                                </CustomBox>
                            </CustomPaper>}
                    </CustomGrid>
                }
            </CustomGrid >

            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />

            {/* Mileage Claim */}
            {mileageClaimDialogOpen &&
                <MileageClaimActionDialog
                    dialogOpen={mileageClaimDialogOpen}
                    dialogClose={(isOpen, confirmReject, reason) =>
                        rejectMileageClaimDialogFunc(isOpen, confirmReject, reason)
                    }
                    mileageClaimStatus={mileageClaimDetailsStatus}
                    dialogMessage={mileageClaimDetailsStatus === MileageClaimStatusEnum.APPROVED ? t("ARE_YOU_SURE_YOU_WANT_TO_APPROVE_THE_MILEAGE_CLAIM") : t("ARE_YOU_SURE_YOU_WANT_TO_REJECT_THE_MILEAGE_CLAIM")}
                />
            }

            {isEventAlertOpen && <ErrorAlert
                code={eventStatusValue}
                message={eventAlertMessage}
                description={eventAlertDescription}
                isOpen={isEventAlertOpen}
                alertType={eventAlertType}
                isClose={(isClose) => setIsEventAlertOpen(!isClose)}
            />}
        </>
    )
}

export default MileageClaimDetails;
